import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box
} from '@mui/material';

interface FeedbackCommentDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (comment?: string) => void;
}

export const FeedbackCommentDialog: React.FC<FeedbackCommentDialogProps> = ({
  open,
  onClose,
  onSubmit
}) => {
  const [comment, setComment] = useState('');
  const maxLength = 1000;

  const handleSubmit = () => {
    onSubmit(comment.trim() || undefined);
    setComment('');
  };

  const handleSkip = () => {
    onSubmit(undefined);
    setComment('');
  };

  const handleClose = () => {
    setComment('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          bgcolor: 'background.paper'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        Was war nicht hilfreich?
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Ihr Feedback hilft uns, die Antworten zu verbessern. (Optional)
        </Typography>

        <TextField
          autoFocus
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          placeholder="z.B. Die Antwort war nicht relevant, fehlende Quellenangaben, ..."
          value={comment}
          onChange={(e) => setComment(e.target.value.slice(0, maxLength))}
          inputProps={{ maxLength }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 1.5
            }
          }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {comment.length}/{maxLength} Zeichen
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleSkip}
          color="inherit"
          sx={{ mr: 1 }}
        >
          Überspringen
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
        >
          Senden
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackCommentDialog;
